import cn from 'classnames';
import { Button } from '../Button';
import styles from './SocialButton.module.scss';

interface SocialButtonProps {
  socialType: 'facebook' | 'whatsapp';
  link?: string;
  className?: string;
}

export const SocialButton = ({
  socialType,
  link,
  className,
}: SocialButtonProps) => (
  <Button
    aria-label={socialType}
    className={cn(styles.root, className)}
    iconPlace="only-icon"
    icon={socialType}
    alt={link}
    onClick={() => {
      if (link) window.open(link, '_blank', 'noopener,noreferrer');
    }}
  />
);
